import {Dialog, DialogContent, useMediaQuery} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import './styless.scss'
import DropWaterDetailSidebar from "../payment/dropWaterDetailSidebar";
import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import DropActiveList from "./dropActiveList";

export default function DropActive (props: {labelDialogOpen: boolean, handleSetLabelDialogControl: ()=>void, handleSetDropActiveDialogControl: () => void, boardId?: string | null}) {

    const memberInfo = useSelector((state: RootState) => state.member.memberInfo);

    const {labelDialogOpen, handleSetLabelDialogControl, handleSetDropActiveDialogControl, boardId} = props;
    const isMobile = useMediaQuery('(max-width:768px)');

    return <div>
        <Dialog
            fullScreen={isMobile}
            open={labelDialogOpen}
            onClose={handleSetDropActiveDialogControl}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="invitation-dialog"
        >
            <DialogContent>
                <div className="invitation-content" style={{backgroundColor: 'var(--c-bg)'}}>
                    <div className="invitation-header">
                        {isMobile && <div></div>}
                        <div className="invitation-title">领取免费水滴活动</div>
                        <div onClick={handleSetDropActiveDialogControl}><CloseIcon
                            sx={{width: isMobile ? 20 : 30, height: isMobile ? 20 : 30, marginTop: '6px'}}/></div>
                    </div>
                    <div className='dropWaterDetailLayout'>
                        <DropWaterDetailSidebar memberInfo={memberInfo}/>
                        <DropActiveList
                          handleSetLabelDialogControl={handleSetLabelDialogControl}
                          memberInfo={memberInfo}
                          boardId={boardId}
                        />
                    </div>
                  </div>
            </DialogContent>
        </Dialog>
    </div>
}